module.exports = __webpack_public_path__ + "static/media/ios-13-step-1.f08a0662.jpeg";